import ExcelJS from "exceljs";
import moment from "moment";

// Funciones auxiliares de formateo
function formatNumber(num) {
  if (num == null) return "";
  return Number(num);
}

// Función auxiliar para formatear la hora usando moment
function formatTime(dateStr) {
  return moment(dateStr).format("HH:mm");
}

// Función auxiliar para buscar el nombre del cajero por Id
function getCajeroName(cajeros, id) {
  if (!cajeros || !Array.isArray(cajeros)) return id;
  const found = cajeros.find((c) => c.Id === id);
  return found ? found.Nomb : id;
}

export default class TransaccionesExcelExporter {
  static async exportReporteTransacciones(
    ventas,
    devoluciones,
    title = "Reporte transacciones",
    contadores = null,
    cajeros
  ) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Transacciones");

    //  Título general
    // Suponiendo 13 columnas para transacciones (de A a M)
    worksheet.mergeCells("A1:M1");
    const titleCell = worksheet.getCell("A1");
    titleCell.value = title;
    titleCell.font = { bold: true, size: 18 };
    titleCell.alignment = { horizontal: "center", vertical: "middle" };
    titleCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFB0C4DE" },
    };

    let currentRow = 2; // siguiente fila

    //  Tabla de contadores totales (opcional)
    if (
      contadores &&
      contadores.encabezados &&
      contadores.dataContador &&
      contadores.totales
    ) {
      // Inserta una fila vacía después del título
      worksheet.addRow([]);
      currentRow++;

      // Encabezado de la tabla de contadores:
      // Columna A: "Corte", luego por cada clave en contadores.encabezados
      const encabezados = Object.keys(contadores.encabezados);
      const contadorHeader = ["Corte", ...encabezados];
      const contadorHeaderRow = worksheet.addRow(contadorHeader);
      contadorHeaderRow.font = { bold: true, size: 12 };
      contadorHeaderRow.alignment = {
        horizontal: "center",
        vertical: "middle",
      };
      contadorHeaderRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFADD8E6" },
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
      currentRow++;

      // Cuerpo de la tabla: iterar sobre contadores.dataContador (se asume que es un objeto)
      for (const cajeroId in contadores.dataContador) {
        const rowDataCont = contadores.dataContador[cajeroId];
        const cajeroNombre = getCajeroName(cajeros, cajeroId);
        const rowArray = [cajeroNombre];
        encabezados.forEach((key) => {
          const valor =
            (rowDataCont[key] != null ? rowDataCont[key] : 0) -
            (key === "EFVO_MXN" ? rowDataCont["Cambio"] || 0 : 0);
          rowArray.push(formatNumber(valor));
        });
        const contadorRow = worksheet.addRow(rowArray);
        contadorRow.alignment = { horizontal: "center", vertical: "middle" };
        contadorRow.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
        currentRow++;
      }

      // Fila de totales
      const totalesRowArray = ["TOTALES"];
      encabezados.forEach((key) => {
        const totalValor =
          (contadores.totales[key] != null ? contadores.totales[key] : 0) -
          (key === "EFVO_MXN" ? contadores.totales["Cambio"] || 0 : 0);
        totalesRowArray.push(formatNumber(totalValor));
      });
      const totalesRow = worksheet.addRow(totalesRowArray);
      totalesRow.font = { bold: true, size: 12 };
      totalesRow.alignment = { horizontal: "center", vertical: "middle" };
      totalesRow.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
      currentRow++;

      // Fila vacía para separar la tabla de contadores del resto
      worksheet.addRow([]);
      currentRow++;
    }

    //  Tabla de transacciones
    // Encabezados fijos (13 columnas, sin incluir "Opciones")
    const transHeader = [
      "Folio venta",
      "Fecha",
      "Hora",
      "Id Autorización",
      "Alias",
      "Cliente",
      "Extra",
      "Cajero",
      "Clave",
      "Tipo de pago",
      "Cantidad Metodo de pago",
      "Moneda",
      "Total Venta",
      "Total Ticket",
      "Estatus",
    ];
    const transHeaderRow = worksheet.addRow(transHeader);
    transHeaderRow.font = { bold: true, size: 12 };
    transHeaderRow.alignment = { horizontal: "center", vertical: "middle" };
    transHeaderRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFADD8E6" },
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    // Agregar filas para ventas (ventas_comp)
    if (ventas && ventas.length > 0) {
      ventas.forEach((res) => {
        if (res.show) {
          // se añade solo si res.show es true
          const rowData = [
            res.Folio,
            res.FechaVenta,
            formatTime(res.FechaCreacion), // Se formatea la hora con moment en formato hh:mm
            res.IdTran,
            (res.Cliente && res.Cliente.Apodo) || "",
            (res.Cliente && res.Cliente.Nombre) || "",
            "Mesero: " + ((res.Mesero && res.Mesero.Nombre) || ""),
            getCajeroName(cajeros, res.Cajero) || "",
            res.clave || "",
            res.TipoPago || "",
            Number(res.Cantidad),
            res.moneda || "",
            Number(res.Total),
            Number((res.PropinaTotal || 0) + (res.Total || 0)),
            res.Devos ? "Devuelto" : "Activo",
          ];
          const row = worksheet.addRow(rowData);
          row.alignment = { horizontal: "left", vertical: "middle" };
          row.eachCell({ includeEmpty: true }, (cell) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          });
          // Aplicar colores de fondo según condiciones
          if (res.prop) {
            // Fondo para propina: lightcyan
            row.eachCell({ includeEmpty: true }, (cell) => {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFE0FFFF" },
              };
            });
          } else if (res.camb) {
            // Fondo para cambio: lightgoldenrodyellow
            row.eachCell({ includeEmpty: true }, (cell) => {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFAFAD2" },
              };
            });
          }
        }
      });
    } else {
      const noDataRow = worksheet.addRow(["No se encontraron datos"]);
      noDataRow.alignment = { horizontal: "center" };
      worksheet.mergeCells(`A${noDataRow.number}:M${noDataRow.number}`);
    }

    // Agregar filas para devoluciones (devoluciones_comp)
    if (devoluciones && devoluciones.length > 0) {
      devoluciones.forEach((dev) => {
        if (dev.show) {
          const rowData = [
            dev.Folio,
            dev.Fecha,
            formatTime(dev.Crat), // Se formatea la hora para devoluciones también
            dev.IdTran,
            (dev.Cliente && dev.Cliente.Apodo) || "",
            (dev.Cliente && dev.Cliente.Nombre) || "",
            "", // Extra
            dev.Cajero || "",
            dev.TipoPago,
            Number(dev.Cantidad),
            Number(dev.Cantidad),
            "", // Total Ticket vacío
            "Devolución",
          ];
          const row = worksheet.addRow(rowData);
          row.alignment = { horizontal: "left", vertical: "middle" };
          row.eachCell({ includeEmpty: true }, (cell) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
            // Fondo distintivo para devoluciones
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFFFE0B2" },
            };
          });
        }
      });
    }

    // Autoajuste de columnas para todo el documento
    worksheet.columns.forEach((column) => {
      let maxLength = 10;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellText = cell.value ? cell.value.toString() : "";
        maxLength = Math.max(maxLength, cellText.length);
      });
      column.width = maxLength + 2;
    });

    return workbook.xlsx.writeBuffer();
  }
}
